import { ApplicationConfig, ErrorHandler, inject, provideEnvironmentInitializer, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideMaplibreWorker } from '@maplibre/ngx-maplibre-gl/config';

import { routes } from './app.routes';
import { CustomErrorHandler } from './services/logging/app-error-handler';
import { BrowserEventsService } from './services/platform/browser-events.service';
import { authInterceptor } from './interceptors/auth.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    // Change detection is driven by signals, not zone.js: state that the templates render
    // is signal-based, so Angular is notified on write rather than after every async task.
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),
    // maplibre-gl v6 externalized its web worker; ngx-maplibre-gl v22 needs the
    // served worker URL (copied to the output root as an asset in angular.json).
    provideMaplibreWorker('maplibre-gl-worker.mjs'),
    { provide: ErrorHandler, useClass: CustomErrorHandler },
    provideEnvironmentInitializer(() => inject(BrowserEventsService)),
  ]
};
